export type UnitTypeKPI = "amount" | "percent";
export enum ProgramStatus {
  Draft = 1,
  InProgress = 3,
  End = 5,
  Closed = 7,
}
export enum KPIApply {
  Personal = 1,
  Department = 3,
}

export interface KPIMasterRankData {
  rankId: string;
  rankName: string;
  level: number;
  status: number;
}

export interface KPIMasterData {
  programId: string;
  programName: string;
  status: ProgramStatus;
  year: number;
  from: string;
  to: string;
  frequency: number;
  description?: string;
  participantCount?: number;
  rankData: KPIMasterRankData[];
  applyFor?: KPIApply;
}

export interface KPIBonusRate {
  rate: number;
  level: number;
  rankId: string;
  status: number;
  rankName: string;
  unitType: UnitTypeKPI;
}

export interface KPISetting {
  id: string;
  status: number;
  orgId: number;
  programId: number;
  programName: string;
  year: number;
  from?: string;
  to?: string;
  bonusRates: KPIBonusRate[];
}

export interface KPISettingListRequest {
  page?: number;
  limit?: number;
  keyword?: string | null;
  status?: number | null;
  year?: number | null;
  programId?: number | null;
}

export interface KPISettingCreateBulkRequest {
  items: {
    programId: number;
    programName: string;
    status: number;
    bonusRates: Array<{
      rankId: string;
      rankName: string;
      level: number;
      status: number;
      rate: number;
      unitType: UnitTypeKPI;
    }>;
  }[];
}

export interface KPISettingCreateRequest {
  programId: number;
  programName: string;
  status: number;
  bonusRates: Array<{
    rankId: string;
    rankName: string;
    level: number;
    status: number;
    rate: number;
    unitType: UnitTypeKPI;
  }>;
}

export interface KPISettingUpdateRequest extends KPISettingCreateRequest {
  id: string;
}

export interface KPISettingListResponse extends RestAPIMetaResponse {
  items: Array<KPISetting>;
  total: number;
  page: number;
  limit: number;
}

export interface KPIMasterDataListResponse extends RestAPIMetaResponse {
  items: Array<KPIMasterData>;
  total: number;
  page: number;
  limit: number;
}
